export const notificationTypes = {
    QUEST_STREAK_INCREMENTED_NOTIFICATION: 'QuestStreakIncrementedNotification',
    QUEST_MISSION_COMPLETED_NOTIFICATION: 'QuestMissionCompletedNotification',
};
